export default __webpack_public_path__ + "static/media/Switch-3.0edb819a.jpg";